ACC.consent = {
    _autoload: [
        ['bindSendConsent', $('#consent-management-form').length !== 0],
        ['bindToggleConsentTemplateDescription', $('#consent-management-form').length !== 0],
        'bindConsentClick',
        'bindConsentManagementAlertBar',
    ],

    bindSendConsent() {
        const consentCheckbox = $('#consent-management-form').find('input.toggle-button__input');

        consentCheckbox.click(function () {
            const consentId = $(this).prop('id');
            const isConsentGiven = $(this).is(':checked');
            const buttonId = (isConsentGiven ? '#give-consent-button-' : '#withdraw-consent-button-') + consentId;
            $(buttonId).trigger('click');

            $(buttonId).on('keydown', (event) => {
                if (event.keyCode === 13 || event.keyCode === 32) {
                    event.preventDefault();
                    $(buttonId).trigger('click');
                }
            });
        });
    },

    bindToggleConsentTemplateDescription() {
        const accordion = $('#consent-management-form').find('[data-behavior="accordion"]');
        const expandedClass = 'is-expanded';

        $.each(accordion, function () {
            const accordionItems = $(this).find('[data-binding="expand-accordion-item"]');

            $.each(accordionItems, function () {
                const $this = $(this);
                const triggerBtn = $this.find('[data-binding="expand-accordion-trigger"]');

                const setHeight = function (nV) {
                    const innerContent = nV.find('.consent-management-list__content-inner')[0];
                    const maxHeight = $(innerContent).outerHeight();
                    const content = nV.find('.consent-management-list__content')[0];

                    if (!content.style.height || content.style.height === '0px') {
                        $(content).css('height', maxHeight);
                    } else {
                        $(content).css('height', '0px');
                    }
                };

                const toggleClasses = function (event) {
                    const clickedItem = event.currentTarget;
                    const currentItem = $(clickedItem).parent();
                    const clickedContent = $(currentItem).find('.consent-management-list__content');
                    $(currentItem).toggleClass(expandedClass);
                    setHeight(currentItem);

                    if ($(currentItem).hasClass('is-expanded')) {
                        $(clickedItem).attr('aria-selected', 'true');
                        $(clickedItem).attr('aria-expanded', 'true');
                        $(clickedContent).attr('aria-hidden', 'false');
                    } else {
                        $(clickedItem).attr('aria-selected', 'false');
                        $(clickedItem).attr('aria-expanded', 'false');
                        $(clickedContent).attr('aria-hidden', 'true');
                    }
                };

                triggerBtn.on('click', (event) => {
                    event.preventDefault();
                    toggleClasses(event);
                });

                // keyboard navigation
                $(triggerBtn).on('keydown', (event) => {
                    if (event.keyCode === 13 || event.keyCode === 32) {
                        event.preventDefault();
                        toggleClasses(event);
                    }
                });
            });
        });
    },

    bindConsentClick() {
        $('.consent-accept').on('click', function () {
            ACC.consent.updateConsent(this, 'GIVEN');
        });

        $('.consent-reject').on('click', function () {
            ACC.consent.updateConsent(this, 'WITHDRAWN');
        });
    },

    changeConsentState(anonymousConsentCookie, consentCode, consentState) {
        anonymousConsentCookie.forEach((consent) => {
            if (consent.templateCode === consentCode) {
                consent.consentState = consentState;
            }
        });
    },

    updateConsent(element, state) {
        const anonymousConsentCookie = JSON.parse(decodeURIComponent($.cookie('anonymous-consents')));
        $(element).closest('.consentmanagement-bar').hide();
        const consentCode = ($(element).closest('.consentmanagement-bar').data('code'));
        ACC.consent.changeConsentState(anonymousConsentCookie, consentCode, state);
        $.cookie('anonymous-consents', JSON.stringify(anonymousConsentCookie), { json: true, path: '/' });
    },

    bindConsentManagementAlertBar() {
        // accordion behaviour
        const accordion = $('#consent-management-alert').find('[data-behavior="accordion"]');
        const expandedClass = 'is-expanded';

        $.each(accordion, function () {
            const accordionItems = $(this).find('[data-binding="expand-accordion-item"]');

            $.each(accordionItems, function () {
                const $this = $(this);
                const triggerBtn = $this.find('[data-binding="expand-accordion-trigger"]');

                const setHeight = function (nV) {
                    const innerContent = nV.find('.consent-management-list__content-inner')[0];
                    const maxHeight = $(innerContent).outerHeight();
                    const content = nV.find('.consent-management-list__content')[0];

                    if (!content.style.height || content.style.height === '0px') {
                        $(content).css('height', maxHeight);
                    } else {
                        $(content).css('height', '0px');
                    }
                };

                const toggleClasses = function (event) {
                    const clickedItem = event.currentTarget;
                    const currentItem = $(clickedItem).parent();
                    const clickedContent = $(currentItem).find('.consent-management-list__content');
                    $(currentItem).toggleClass(expandedClass);
                    setHeight(currentItem);

                    if ($(currentItem).hasClass('is-expanded')) {
                        $(clickedItem).attr('aria-selected', 'true');
                        $(clickedItem).attr('aria-expanded', 'true');
                        $(clickedContent).attr('aria-hidden', 'false');
                    } else {
                        $(clickedItem).attr('aria-selected', 'false');
                        $(clickedItem).attr('aria-expanded', 'false');
                        $(clickedContent).attr('aria-hidden', 'true');
                    }
                };

                triggerBtn.on('click', (event) => {
                    event.preventDefault();
                    toggleClasses(event);
                });

                // keyboard navigation
                $(triggerBtn).on('keydown', (event) => {
                    if (event.keyCode === 13 || event.keyCode === 32) {
                        event.preventDefault();
                        toggleClasses(event);
                    }
                });
            });
        });
    },

};
